import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";

const SendCampaignDialog = ({
  open,
  onClose,
  onConfirm,
  campaign,
  sending,
}) => {
  const [sendCount, setSendCount] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");
    setSendCount(
      campaign?.batchSize ? String(campaign.batchSize) : "100"
    );
  }, [open, campaign]);

  const handleConfirm = async () => {
    setError("");
    const payload = {};
    const count = Number(sendCount);
    if (count > 0) {
      payload.sendCount = count;
    }

    const result = await onConfirm(payload);
    if (result?.error) setError(result.error);
  };

  const pending = campaign?.remainingCount ?? 0;
  const prepared = campaign?.recipientCount ?? 0;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>ارسال دسته آماده‌شده</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          ارسال کمپین با توجه به تنظیمات و وضعیت فعلی توسط سرور تصمیم‌گیری می‌شود.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          آماده ارسال: {pending} | کل آماده‌شده: {prepared} | ارسال‌شده: {campaign?.sentCount ?? 0} | ناموفق: {campaign?.failedCount ?? 0}
        </Typography>
        <TextField
          label="تعداد ارسال در این مرحله (اختیاری)"
          type="number"
          fullWidth
          value={sendCount}
          onChange={(e) => setSendCount(e.target.value)}
          helperText={`اگر عدد وارد نشود، سرور رفتار مناسب را براساس نوع ارسال انتخاب می‌کند.`}
          sx={{ mb: 1 }}
        />
        {error ? (
          <TextField error helperText={error} fullWidth disabled sx={{ mt: 1 }} />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={sending}>
          انصراف
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={sending}
        >
          {sending ? "در حال ارسال..." : "ارسال دسته آماده‌شده"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendCampaignDialog;
